import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_item_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_0_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  category_0_code: fromDatatype.VarcharDatatypeInterface;
  category_1_code: fromDatatype.VarcharDatatypeInterface;
  category_2_code: fromDatatype.VarcharDatatypeInterface;
  category_3_code: fromDatatype.VarcharDatatypeInterface;
  category_4_code: fromDatatype.VarcharDatatypeInterface;
  category_5_code: fromDatatype.VarcharDatatypeInterface;
  category_6_code: fromDatatype.VarcharDatatypeInterface;
  category_7_code: fromDatatype.VarcharDatatypeInterface;
  category_8_code: fromDatatype.VarcharDatatypeInterface;
  category_9_code: fromDatatype.VarcharDatatypeInterface;
  category_10_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_budget_item_RowClass
  implements bl_fi_budget_item_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_0_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  category_0_code: fromDatatype.VarcharDatatypeInterface;
  category_1_code: fromDatatype.VarcharDatatypeInterface;
  category_2_code: fromDatatype.VarcharDatatypeInterface;
  category_3_code: fromDatatype.VarcharDatatypeInterface;
  category_4_code: fromDatatype.VarcharDatatypeInterface;
  category_5_code: fromDatatype.VarcharDatatypeInterface;
  category_6_code: fromDatatype.VarcharDatatypeInterface;
  category_7_code: fromDatatype.VarcharDatatypeInterface;
  category_8_code: fromDatatype.VarcharDatatypeInterface;
  category_9_code: fromDatatype.VarcharDatatypeInterface;
  category_10_code: fromDatatype.VarcharDatatypeInterface;
}
